export default __webpack_public_path__ + "static/media/nextJS.330fb71c.svg";